export default "__VITE_ASSET__DDlV9aSz__"